import { useCallback } from 'react';

import type { UrlTilePayload } from './types';
import { useOptionalUrlTiles } from './use-url-tiles';

export const useOpenTileSelection = ({
    selectId,
    slotKey,
}: {
    readonly selectId: (payload: UrlTilePayload) => string | undefined;
    readonly slotKey: string;
}): ((id: string) => boolean) => {
    const context = useOptionalUrlTiles();
    const openTile = context?.tiles.find((tile) => tile.slotKey === slotKey);
    const selectedId = openTile === undefined ? undefined : selectId(openTile.payload);

    return useCallback((id: string) => selectedId !== undefined && id === selectedId, [selectedId]);
};
